import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { EntityTable } from '../components/common/EntityTable';
import { useEntities } from '../hooks/useEntities';
import { getEntityConfig } from '../lib/entity-config';

export function EntityListPage() {
  const { entityName } = useParams<{ entityName: string }>();
  const config = getEntityConfig(entityName ?? '');
  const { records, isLoading } = useEntities(entityName ?? '');

  if (!config) {
    return <div className="text-red-500">Unknown entity: {entityName}</div>;
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-slate-900">{config.pluralName}</h2>
        <Link
          to={`/${entityName}/new`}
          className="px-4 py-2 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
        >
          Create {config.displayName}
        </Link>
      </div>
      <EntityTable
        records={records}
        columns={config.listColumns}
        entityName={entityName!}
        primaryKeyField={config.primaryKeyField}
        isLoading={isLoading}
      />
    </div>
  );
}
